import React, { useState, useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";
import GoalTypeModal from "../../core/modals/goalTypeModal";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import {
  createGoaltype,
  fetchAllGoaltype,
  deleteGoaltype,
  UpdateGoaltype,
} from "../../core/data/redux/performance/goaltype/goaltypeAction";
import DeleteModal1 from "../../core/modals/deleteModal1";
import Select from "react-select";
import { Drawer, message } from "antd";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";

const GoalType = () => {
  const statusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];
  const dispatch = useDispatch<AppDispatch>();
  const { goaltype } = useSelector((state: any) => state.performance.goaltype);
  const [tableKey, setTableKey] = useState(0);
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const goaltypeId = selectedRowData?.Id;
  const [errors, setErrors] = useState<any>({});
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [iseditDrawerVisible, setIseditDrawerVisible] = useState(false);
  const [formData, setFormData] = useState<any>({
    Goaltype: "",
    Description: "",
    Status: statusOptions[0],
    Id: "",
  });

  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [selectedStatus, setSelectedStatus] = useState("active");

  const location = useLocation();
  const { permissions, label } = location.state || {};
  const canView =
    permissions?.includes("View") || permissions?.includes("AllowAll");
  const canEdit =
    permissions?.includes("Edit") || permissions?.includes("AllowAll");
  const canDelete =
    permissions?.includes("Delete") || permissions?.includes("AllowAll");

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, goaltype]);

  useEffect(() => {
    dispatch(fetchAllGoaltype());
  }, []);
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectChange = (selectedOption: any) => {
    setFormData({
      ...formData,
      Status: selectedOption.value,
    });
  };

  const validateForm = () => {
    let formIsValid = true;

    let newErrors: any = {
      Goaltype: "",
      Description: "",
      Status: "",
    };

    if (!formData.Goaltype) {
      formIsValid = false;
      newErrors.Goaltype = "Goal Type is required.";
    }


    if (!formData.Status || formData.Status.value === "Select") {
      formIsValid = false;
      newErrors.Status = "Status is required.";
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleUpdateGoaltype = (e: any) => {
    e.preventDefault();

    if (!validateForm()) return;

    dispatch(UpdateGoaltype({ goaltypeId, data: formData }))
      .then((res: any) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          dispatch(fetchAllGoaltype())
          setIseditDrawerVisible(false);
        } else {
          message.warning(res.payload.message);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  const handleDeletePolicy = (goaltypeId: any) => {
    dispatch(deleteGoaltype(goaltypeId))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          message.success(resp.payload.message);
          dispatch(fetchAllGoaltype());
          setIseditDrawerVisible(false);
        } else {
          setIsDeleteModalVisible(false);
          message.warning(resp.payload.message);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  const handleEditPolicy = (record: any): void => {
    setSelectedRowData(record);
    setFormData({
      Goaltype: record.Type,
      Description: record.Description,
      Status: record.Status,
      Id: record.Id,
    });
  };

  const routes = all_routes;
  const data = goaltype;

  const filteredData = useMemo(() => {
      return filterData(
        data || [],
        { Status: selectedStatus },
        "created_at",
        "created_at",
        selectedSort
      );
    }, [dispatch, goaltype, selectedSort, selectedStatus]);
  
    useEffect(() => {
      setTableKey((prevKey) => prevKey + 1);
    }, [dispatch, goaltype, selectedSort, selectedStatus]);


  const columns = [
    {
      title: "Type",
      dataIndex: "Type",
      sorter: (a: any, b: any) => a.Type.length - b.Type.length,
    },
    {
      title: "Description",
      dataIndex: "Description",
      sorter: (a: any, b: any) => a.Description.length - b.Description.length,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => {
        const badgeClass =
          text === "active" ? "badge badge-success" : "badge badge-danger";

        return (
          <span
            className={`${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

          </span>
        );
      },
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link to="#"data-bs-toggle="tooltip"
            data-bs-placement="top"
              title="Edit">
            <i
              className="ti ti-edit"
              onClick={() => {
                handleEditPolicy(record);
                setIseditDrawerVisible(true);
              }}
            />
          </Link>
          <Link to="#"data-bs-toggle="tooltip"
              data-bs-placement="top"
               title="Delete">
            <i
              className="ti ti-trash"
              onClick={() => {
                setSelectedRowData(record);
                setIsDeleteModalVisible(true);
              }}
            />
          </Link>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div>
        <div className="">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Goal Type</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Performance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Add New Goal Type{" "}
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
             
              <div className="mb-2">
                <Link
                  to="#"
                  className="btn btn-primary d-flex align-items-center"
                  onClick={() => {
                    setIsEditing(false);
                    setIsDrawerVisible(true);
                  }}
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Goal Type{" "}
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Goal Type List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                 <div className="dropdown me-3">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  {selectedStatus
                    ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                    : "Select Status"}
                </Link>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedStatus("active")}
                      className="dropdown-item rounded-1"
                    >
                      Active
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedStatus("inactive")}
                      className="dropdown-item rounded-1"
                    >
                      Inactive
                    </Link>
                  </li>
                </ul>
              </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By : Last 7 Days
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Desending
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      <GoalTypeModal
        visible={isDrawerVisible}
        onClose={() => setIsDrawerVisible(false)}
      />

      <Drawer
        title="Edit Goal type"
        placement="right"
        onClose={() => setIseditDrawerVisible(false)}
        open={iseditDrawerVisible}
        width={480}
        style={{ marginTop: 50 }}
      >
        <form onSubmit={handleUpdateGoaltype}>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Goal Type <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="Goaltype"
                    value={formData.Goaltype}
                    onChange={handleChange}
                  />
                  {errors.Goaltype && (
                    <div style={{ color: "red" }}>{errors.Goaltype}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Status <span className="text-danger"> *</span>
                  </label>
                  <Select
                    className="select"
                    options={statusOptions}
                    value={statusOptions.find(
                      (option) => option.value === formData.Status
                    )}
                    onChange={handleSelectChange}
                  />
                  {errors.Status && (
                    <div style={{ color: "red" }}>{errors.Status}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Description 
                  </label>
                  <textarea
                    className="form-control"
                    name="Description"
                    value={formData.Description}
                    onChange={handleChange}
                  />
                  {errors.Description && (
                    <div style={{ color: "red" }}>{errors.Description}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={() => setIseditDrawerVisible(false)}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Save Changes
            </button>
          </div>
        </form>
      </Drawer>

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.Id && handleDeletePolicy(selectedRowData.Id)
        }
      />
    </>
  );
};

export default GoalType;
